import api from './api';
import { invoiceListPath } from './invoiceList.service';

export interface AccrualQuery { begin: string; end: string; show_mules: boolean }
export interface AccrualRow extends Record<string, unknown> {
  pronumber: number;
  masterpro: string;
  billto: number;
  billtoname: string;
  invhistoryrecno: number;
  delivery_date: string | null;
  terminate_date: string | null;
  invoice_date: string | null;
  invoicetotal: number;
  creditamt: number;
  invoice_net: number;
  allocation_difference: number;
  errors: string;
}
export interface AccrualResponse {
  rows: AccrualRow[];
  invoiceTotal: number;
  errorsTotal: number;
  errorCount: number;
  totals: Record<string, number>;
  begin: string;
  end: string;
  showMules: boolean;
  invoiceMonth: string;
}
export const ACCRUAL_REGIONS = [
  ['houston', 'Houston'], ['dallas', 'Dallas'], ['jacksonville', 'Jacksonville'],
  ['mobile', 'Mobile'], ['neworleans', 'New Orleans'], ['memphis', 'Memphis'],
  ['norfolk', 'Norfolk'], ['savannah', 'Savannah'], ['charleston', 'Charleston'],
  ['baltimore', 'Baltimore'], ['chicago', 'Chicago'], ['GWI05', 'BBC'],
  ['GWI08A', 'Bayport A'], ['GWI08B', 'Bayport B'], ['other', 'Other'],
] as const;

export async function getDriverPayrollAccrual(query: AccrualQuery): Promise<AccrualResponse> {
  return (await api.get<AccrualResponse>('/accounting-dashboards/driver-payroll-accrual', { params: query })).data;
}

export function accrualInvoiceHref(row: AccrualRow): string {
  const params = row.invhistoryrecno
    ? { invhistoryrecno: row.invhistoryrecno }
    : { masterpro: row.masterpro, billto: row.billto };
  return invoiceListPath(params);
}
